import React from "react";
import "../styles/codebase.css";

export default function ProgressBar({ title, percent, subtitle }) {
  const pct = Math.max(0, Math.min(100, Number(percent || 0)));

  return (
    <div className="cb-progress">
      <div className="cb-progress-top">
        <div className="cb-progress-title">{title || "Progress"}</div>
        <div className="cb-progress-pct">{pct}%</div>
      </div>

      <div className="cb-progress-bar">
        <div className="cb-progress-fill" style={{ width: `${pct}%` }} />
      </div>

      {subtitle ? <div className="cb-progress-sub">{subtitle}</div> : null}
    </div>
  );
}
